import { Chat } from "portal/components/chat/Chat";
import { idmApi } from "portal/state/idmApi";
import { Loading } from "portal/components/Loading";
import { portalApi } from "portal/state/portalApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useJigsawMetrics } from "../../utils/hooks/useJigsawMetrics";
import { useParams } from "react-router-dom";
import { useSelf } from "portal/state/store";
import { useTranslation } from "react-i18next";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import React, { FunctionComponent } from "react";

const _RobotSupport: FunctionComponent = () => {
  const { serial } = useParams();
  const { i18n } = useTranslation();
  const useJigsaw = useJigsawMetrics();

  const { data: token } = idmApi.endpoints.getStreamToken.useQuery();
  const { user } = useSelf();
  const { data: robot } = portalApi.endpoints.getRobot.useQuery(
    serial ? { language: i18n.language, serial, useJigsaw } : skipToken
  );

  if (!serial || !robot || !user || !token) {
    return <Loading />;
  }
  return (
    <Chat
      serial={serial}
      customerSerial={robot.robot?.customerSerial || serial}
      className="-mt-10"
      user={user}
      token={token}
    />
  );
};

export const RobotSupport = withAuthenticationRequired(_RobotSupport);
